import React from 'react';
import './option-indicator.css';
import { Icon } from '../../../../../components/icon';

const OptionIndicator = props => {
    const { optionsLength, activeOption } = props;

    return (
        <div className="option-indicator" aria-label="option indicator">
            {Array.from(Array(optionsLength), (option, i) => {
                if (activeOption === i) {
                    return (
                        <div
                            className="option-indicator__option"
                            aria-label={`option ${i + 1} active`}
                            role="img"
                            key={i}
                        >
                            <Icon
                                iconName="messages"
                                colorScheme="dark"
                                size="x-small"
                            />
                        </div>
                    );
                } else {
                    return (
                        <div
                            className="option-indicator__option"
                            aria-label={`option ${i + 1} inactive`}
                            key={i}
                        >
                            <span
                                className="option-indicator__option--inactive"
                                key={i}
                            />
                        </div>
                    );
                }
            })}
        </div>
    );
};

export { OptionIndicator };
